import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";

@Directive({
  selector: "[appIntersectObserver]",
  standalone: true,
})
export class IntersectObserverDirective implements OnInit, OnDestroy {
  @Output() appIntersect = new EventEmitter<void>();

  @Input() once = true;

  private observer?: IntersectionObserver;

  private locked = false;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting || this.locked) return;

        // Lock to avoid duplicates
        this.locked = true;

        // Small debounce to avoid micro scroll flaps
        requestAnimationFrame(() => {
          this.appIntersect.emit();

          if (this.once) {
            this.observer?.disconnect();
          }
        });
      },
      { threshold: 0.1 },
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
